export default [
  'fetch_courses@list',
  'fetch_course@single',
  'update_course@single',
  'create_course@created',
  'remove_course',
];
